import { useAppSelector } from '@shared/lib/redux'

import { addressStore } from './address.slice'

export const useCurrentCity = () => {
  return useAppSelector(addressStore.selectors.selectCurrentCity)
}

export const useCurrentAddress = () => {
  return useAppSelector(addressStore.selectors.selectCurrentAddress)
}

export const useCityList = () => {
  const cityListState = useAppSelector(addressStore.selectors.selectCityList)
  return {
    ...cityListState
  }
}

export const useAddressList = () => {
  const addressListState = useAppSelector(
    addressStore.selectors.selectAddressList
  )
  return {
    ...addressListState
  }
}
